export const tabelaPrecoFilterConfig = [
  {
    id: 'NomeTabelaPrecoDeposito',
    type: 'text',
    label: 'Nome',
    placeholder: 'Digite o nome da tabela'
  },
  {
    id: 'NomeResponsavel',
    type: 'text',
    label: 'Nome Responsavel',
    placeholder: 'Digite o nome do responsavel'
  },
  {
    id: 'CNPJCliente',
    type: 'text',
    label: 'CNPJ Cliente',
    placeholder: 'Digite o CNPJ do cliente'
  },
  {
    id: 'SemCliente',
    type: 'checkbox',
    label: 'Sem Cliente'
  },
  {
    id: 'Freetime',
    type: 'number',
    label: 'Freetime',
    placeholder: 'Dias de freetime'
  },
  {
    id: 'DataVigenciaInicioInicio',
    type: 'date',
    label: 'Vigencia Inicio (Inicio)'
  },
  {
    id: 'DataVigenciaInicioFim',
    type: 'date',
    label: 'Vigencia Inicio (Fim)'
  },
  {
    id: 'DataVigenciaFimInicio',
    type: 'date',
    label: 'Vigencia Fim (Inicio)'
  },
  {
    id: 'DataVigenciaFimFim',
    type: 'date',
    label: 'Vigencia Fim (Fim)'
  }
];
